import { defineStore } from 'pinia';
import { get_all_accounts } from '../services/ml_account.service.ts';

export const useAccountStore = defineStore('account', {
    state: () => ({
        accounts: [] as any[],
        selectedAccount: null,
        loading: false,
        loaded: false,
        error: null as string | null
    }),
    actions: {
        setAccounts(accounts: any[]) {
            this.accounts = accounts;
        },

        setSelectedAccount(account: any) {
            this.selectedAccount = account;
        },

        async fetchAccounts() {
            this.loading = true;
            this.error = null;
            try {
                const response = await get_all_accounts();
                this.setAccounts(response.data.data);
                this.loaded = true;
            } catch (error: any) {
                this.error = error?.response?.data?.message ?? 'No se pudieron cargar las cuentas';
            } finally {
                this.loading = false;
            }
        }
    }
});

export default useAccountStore;
